import { type COLOR, getColorValue, getProductColorShade } from '@george-labs.com/design-system';

export const getColorStrengthHexValues = (color: COLOR): { weak: string; strong: string } => {
    const weakColor = getProductColorShade(color, 'weak');
    const strongColor = getProductColorShade(color, 'strong');

    return { weak: getColorValue(weakColor), strong: getColorValue(strongColor) };
};
